import { Flag, MapTrifold, Trophy, Wrench, ChartBar } from "@phosphor-icons/react";

const CASCADE = [
  { key: "aspiration", n: 1, title: "Winning Aspiration", icon: Trophy },
  { key: "whereToPlay", n: 2, title: "Where to Play", icon: MapTrifold },
  { key: "howToWin", n: 3, title: "How to Win", icon: Flag },
  { key: "capabilities", n: 4, title: "Core Capabilities", icon: Wrench },
  { key: "systems", n: 5, title: "Management Systems", icon: ChartBar },
];

export default function PlayingToWinBlueprint({ doc }) {
  const p = doc.payload || {};
  return (
    <div className="space-y-3" data-testid="ptw-blueprint">
      {CASCADE.map((c, i) => (
        <div key={c.key} className="relative" data-testid={`ptw-block-${c.key}`}>
          <div className="bg-white border border-slate-200 rounded-sm overflow-hidden">
            <div className="px-5 py-3 border-b border-slate-100 flex items-center gap-3 bg-slate-50">
              <span className="w-7 h-7 rounded-sm bg-slate-900 text-white font-mono text-xs font-bold flex items-center justify-center">{c.n}</span>
              <c.icon size={18} weight="duotone" className="text-indigo-700" />
              <h3 className="text-sm font-semibold tracking-wide uppercase text-slate-700">{c.title}</h3>
            </div>
            <div className="p-5">
              <p className="text-sm text-slate-800 whitespace-pre-wrap leading-relaxed">{p[c.key] || <span className="text-slate-300">—</span>}</p>
            </div>
          </div>
          {i < CASCADE.length - 1 && <div className="mx-auto w-px h-3 bg-indigo-300" />}
        </div>
      ))}
    </div>
  );
}
